import React, { ReactNode } from 'react'
import { styled } from '@mui/material'
import { muiColors, muiTypography } from '@zuto/theme/src/mui/DefaultTheme'
import EditIcon from '@mui/icons-material/Edit'

interface ButtonWithIconProps {
  text?: string
  icon?: ReactNode
  testId?: string
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const ButtonWithIconContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: muiColors.primary.yellow,
  borderRadius: '25px',
  padding: '10px 12px',
  cursor: 'pointer',
  p: {
    ...muiTypography.body.text.medium,
    margin: 0,
    paddingLeft: '5px',
    color: muiColors.primary.blackAlt
  },
  svg: {
    paddingBottom: '2px'
  }
})

const ButtonWithIcon = ({
  text,
  icon,
  testId,
  onClick
}: ButtonWithIconProps): JSX.Element => (
  <ButtonWithIconContainer
    data-testid={testId}
    id={testId}
    onClick={onClick}
  >
    {icon || (
      <EditIcon
        data-testid="default-icon"
        sx={{ color: muiColors.primary.blackAlt, width: '17px', height: '17px' }}
      />
    )}
    <p data-testid="button-text">{text || 'Edit Details'}</p>
  </ButtonWithIconContainer>
)

export default ButtonWithIcon
